import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
  selector: 'inherent-risk',
  templateUrl: './inherent-risk.component.html',
  standalone: false
})
export class InherentRiskPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  inherentRisk: any;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.inherentRisk = this.plugin.config.InherentRisk;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId,
      'plugins',
      this.plugin.id,
      'inherentrisk',
      'edit'
    ];
  }
}

PluginComponent.plugins['inherentrisk'] = InherentRiskPluginComponent;
